'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
var CLOSE = exports.CLOSE = 'EXPIRED_SESSION_MODAL:CLOSE';

var ExpiredSessionModalActions = {
	close: function close() {
		return { type: CLOSE };
	}
};

exports.default = ExpiredSessionModalActions;